import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../ui/SectionHeading';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import EcosystemVisual from '../visuals/EcosystemVisual';

const Ecosystem = () => {
  const points = [
    { text: "Guest posts for authority", icon: FiIcons.FiEdit3, color: "text-blue-400" },
    { text: "Link insertions for relevance", icon: FiIcons.FiLink, color: "text-purple-400" },
    { text: "Reddit for trust signals", icon: FiIcons.FiMessageSquare, color: "text-orange-400" },
    { text: "Quora for search traffic", icon: FiIcons.FiHelpCircle, color: "text-red-400" },
    { text: "PR for brand credibility", icon: FiIcons.FiTrendingUp, color: "text-green-400" },
    { text: "Google Maps Local SEO", icon: FaIcons.FaGoogle, color: "text-blue-500" }
  ];

  return (
    <section className="py-24 relative" id="ecosystem">
      <div className="max-w-7xl mx-auto px-6">
        <SectionHeading
          headline="Dominate the Entire SEO Ecosystem"
          subheadline="Your customers don't search in one place. We orchestrate your brand presence across the platforms that dictate global rankings."
        />

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 mt-12 md:mt-20">
          {/* Content */}
          <div className="w-full lg:w-1/2 order-2 lg:order-1">
            <div className="space-y-4">
              {points.map((point, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-center gap-4 p-4 rounded-2xl glass-card border-white/5 hover:border-white/10 transition-all group"
                >
                  <div className={`w-10 h-10 rounded-xl bg-slate-800 flex items-center justify-center ${point.color} group-hover:scale-110 transition-transform`}>
                    <SafeIcon icon={point.icon} />
                  </div>
                  <span className="text-slate-200 font-bold text-sm md:text-base">{point.text}</span>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Visual - Hidden on mobile, shown on md and above */}
          <div className="hidden md:block w-full lg:w-1/2 order-1 lg:order-2">
            <div className="relative w-full aspect-square max-w-[500px] mx-auto scale-90 md:scale-100">
              <EcosystemVisual />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ecosystem;